import { PageContainer, ContainerAtTop } from './styles';
import Logo from 'design-system/src/assets/icons/logoLong.svg?react';

const LogoAtTop = () => {
  return (
    <ContainerAtTop>
      <Logo />
    </ContainerAtTop>
  );
};

export const PageContainerWithLogo = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <PageContainer className={className} {...props}>
      <LogoAtTop />
      {children}
    </PageContainer>
  );
};
